import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import { Link } from './localizedlink'
import { injectIntl, FormattedMessage } from 'react-intl'
import { findLocalized } from '../utils'

import logo from '../images/logo.svg'
import logoIMwhite from '../images/intranet-management-logo-white.png';
import logoAGwhite from '../images/ariadne-group-logo-white.png';


const normalizeNumber = number => (number.startsWith('+39') ? number : `+39${number}`).replace(/\s/g, '');

const FooterOnline = ({ intl: { locale } }) => {
  const { allFooterYaml } = useStaticQuery(graphql`
    query {  
      allFooterYaml{
        edges{
          node{
            contacts_list{
              text
              tel
              email
            }
            contacts_bottom
            location
            address
            claim
            lang
          }
        }
      }     
    }
  `);
  const { contacts_list, contacts_bottom, claim } = findLocalized(allFooterYaml, locale);
  return (
    <div className="footer-online">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-3 d-flex flex-column">
                <img src={logo} alt="Intranet Italia Day" className="footer-online__img" />
                <div className="footer-online__social">
                  <a href="https://fb.me/IntranetItaliaDay" target="_blank" rel="noopener noreferrer" title="Facebook" className="">
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                  <a href="https://twitter.com/Intranet_IT_Day" target="_blank" rel="noopener noreferrer" title="Twitter" className="">
                    <i className="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/intranet-italia-day/" target="_blank" rel="noopener noreferrer" title="LinkedIn" className="">
                    <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <div className="col-sm-5">
                <ul className="footer-online__list">
                  <li className="footer-online__item">
                    <Link className="footer-online__live" to="/">
                      <FormattedMessage id="go-live-site" />
                    </Link>
                  </li>
                </ul>
                <div className="footer-online__contacts">
                  {contacts_list.map((contact, i) => (
                    <React.Fragment key={i}>
                      {contact.tel && <a href={`tel:${normalizeNumber(contact.tel)}`}>{`${contact.text} ${contact.tel}`}</a>}
                      {contact.email && <a href={`mailto:${contact.email}`}>{`${contact.text} ${contact.email}`}</a>}
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="footer-online__claim">
                  <div dangerouslySetInnerHTML={{ __html: claim }}></div>
                  <div className="logos-wrapper">
                    <a href="https://www.intranetmanagement.it/" title="Intranet Management" className="imglink" target="_blank" rel="noopener noreferrer">
                      <img src={logoIMwhite} alt="Intranet Management - Logo bianco" className="footer-online__img" />
                    </a>
                    <a href="https://www.ariadnegroup.it/" title="Ariadne Group" className="imglink imglink--ag" target="_blank" rel="noopener noreferrer">
                      <img src={logoAGwhite} alt="Ariadne Group - Logo bianco" className="footer-online__img" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="footer-online__bottom" dangerouslySetInnerHTML={{ __html: contacts_bottom }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )

}

export default injectIntl(FooterOnline);
